/** Límites y packs OCR — mantener alineado con backend/constants/ocrPlans.js */

export const OCR_MONTHLY_LIMIT = {
  basico: 0,
  profesional: 40,
  empresarial: 150,
};

export const OCR_TRIAL_LIFETIME = 3;

export const OCR_OVERAGE_PACKS = [
  { id: 'ocr_25', label: '+25 escaneos', scans: 25, price: 3500 },
  { id: 'ocr_50', label: '+50 escaneos', scans: 50, price: 6500 },
  { id: 'ocr_100', label: '+100 escaneos', scans: 100, price: 11000 },
];

export function getOcrLimitLabel(slug) {
  const s = String(slug || 'basico').toLowerCase();
  if (s === 'profesional') return `${OCR_MONTHLY_LIMIT.profesional} escaneos/mes`;
  if (s === 'empresarial') return `${OCR_MONTHLY_LIMIT.empresarial} escaneos/mes`;
  return `${OCR_TRIAL_LIFETIME} pruebas (total)`;
}
